<template>
  <AppPageCard>
    <template #card-title> Employee Monthly Attendance Report</template>
    <template #card-toolbar>
      <AppRefreshButton @refresh-clicked="fetch"></AppRefreshButton>
    </template>
    <div
      class="
        d-flex
        flex-column flex-lg-row
        bg-light-primary
        p-3
        rounded
        justify-content-between
      "
    >
      <AppFieldDateSelector @clickedSearch="changeDate"></AppFieldDateSelector>
      <EmployeeMonthlyExportControl></EmployeeMonthlyExportControl>
    </div>
    <!-- begin: export table   -->
    <EmployeeAttendanceExportTable
      :is-busy="isBusy"
      :items="items"
      :fields="fields"
      :leaves="modifiedLeaves"
      :aways="modifiedAways"
    ></EmployeeAttendanceExportTable>
    <!-- end: export table   -->

    <!-- start: pagination    -->
    <div class="d-flex justify-content-end" v-if="items.length">
      <b-pagination
        pills
        size="lg"
        class="pt-5"
        @change="changePage"
        v-model="pagination.current_page"
        :total-rows="pagination.total"
        :per-page="pagination.per_page"
      ></b-pagination>
    </div>
    <!-- end: pagination    -->

    <div class="my-4">
      <EmployeeExportLegend
        is-row
        :leaves="leaves"
        :aways="aways"
      ></EmployeeExportLegend>
    </div>
  </AppPageCard>
</template>

<script>
import { mapGetters } from "vuex";
import i18n from "@/core/plugins/vue-i18n";
import dayjs from "dayjs";
import ColumnService from "@/modules/company/services/management/attendance/employee_export_column.service";
import AppPageCard from "@/modules/core/components/shared/card/AppPageCard";
import AppRefreshButton from "@/modules/core/components/button/AppRefreshButton";
import AppFieldDateSelector from "@/modules/core/components/utility/date/AppFieldDateSelector";
import EmployeeMonthlyExportControl from "@/modules/company/components/attendance/export/monthly/EmployeeMonthlyExportControl";
import EmployeeAttendanceExportTable from "@/modules/company/components/attendance/export/EmployeeAttendanceExportTable";
import EmployeeExportLegend from "@/modules/company/components/shared/export/EmployeeExportLegend";
export default {
  name: "EmployeeExportMonthlyAttendancePage",
  components: {
    EmployeeExportLegend,
    EmployeeAttendanceExportTable,
    EmployeeMonthlyExportControl,
    AppFieldDateSelector,
    AppRefreshButton,
    AppPageCard,
  },
  data() {
    return {
      isBusy: false,
      fields: [
        { key: "index", label: "#" },
        { key: "employee", label: i18n.t("EMPLOYEE.HEADER") },
        { key: "employee.present_count", label: "P" },
        { key: "employee.absent_count", label: "AB" },
        { key: "employee.holiday_count", label: "Ho" },
      ],
      modifiedLeaves: [],
      modifiedAways: [],
    };
  },
  mounted() {
    this.fetch();
    this.fetchCompanyAways();
  },
  methods: {
    /**
     * Fetch export list
     */
    fetch() {
      this.isBusy = true;
      this.$store
        .dispatch("fetchEmployeeMonthlyAttendanceExportList")
        .finally(() => (this.isBusy = false));
    },

    fetchCompanyAways() {
      this.$store.dispatch("fetchCompanyAwayDetailList").then((res) => {
        console.log(res.data);
        this.appendAwayFields();
        this.fetchCompanyLeaves();
      });
    },

    /**
     * Fetch school leaves
     */
    fetchCompanyLeaves() {
      this.$store.dispatch("fetchCompanyLeaveList").then(() => {
        // console.log("Here is Leave", res.data);
        this.appendFields();
      });
    },

    appendAwayFields() {
      console.log("Aways: ", this.aways);
      let colAways = [];
      colAways = ColumnService.generateAwayCols(this.aways);
      this.fields.push(...colAways);
      this.modifiedAways = colAways;
    },

    /**
     * Append to existing column fields to
     *
     * 1. Create columns of leave with leave id as the key and name as value.
     * 2. Add weekends value column.
     * 3. Add Total current/total day column.
     */
    appendFields() {
      console.log("Yoichi");
      console.log("Leaves: ", this.leaves);

      let cols = [];

      cols = ColumnService.generateLeaveCols(this.leaves);
      this.fields.push(...cols);
      this.fields.push(
        { key: "employee.offdays_count", label: "X" },
        { key: "total.current", label: "TOT" }
      );
      this.modifiedLeaves = cols;

      console.log("Fields", this.fields);
    },

    /**
     * Handle page change event.
     * @param page value of page
     */
    changePage(page) {
      console.log(page);

      this.$store.commit("setEmployeeMonthlyAttendanceExportListPage", page);
      this.fetch();
    },

    /**
     * Handle date change.
     *
     * @param data
     */
    changeDate(data) {
      console.log(data);

      const objectSupport = require("dayjs/plugin/objectSupport");
      dayjs.extend(objectSupport);

      const date = dayjs({
        day: dayjs().format("D"),
        year: data.year,
        month: data.month,
      });

      this.$store.commit(
        "setEmployeeMonthlyAttendanceExportDateFilter",
        date.format()
      );

      this.fetch();
    },
  },
  computed: {
    ...mapGetters({
      items: "getEmployeeMonthlyAttendanceExportList",
      pagination: "getEmployeeMonthlyAttendanceExportListPagination",
      leaves: "getCompanyLeaveList",
      aways: "getCompanyAwayDetailList",
    }),
  },
};
</script>

<style scoped></style>
